module.exports = __webpack_public_path__ + "static/media/toolbar-zoom-normal.0524f54b.svg";